import React from "react";
import { AiOutlineInfoCircle } from 'react-icons/ai';

const MissingTopics = ({
  topEngTopics = [],
  topMathTopics = [],
  handleRowClick,
  setdashboard,
  setInfoMessage
}) => {
  const toOrdinal = (num) => {
    if (num === 1) return "1st";
    if (num === 2) return "2nd";
    if (num === 3) return "3rd";
    return `${num}th`;
  };

  const getWrongStyle = (rate) => {
    if (rate >= 80) return { color: '#dc2626', bg: '#fef2f2', border: '#fecaca' };
    if (rate >= 60) return { color: '#ea580c', bg: '#fff7ed', border: '#fed7aa' };
    if (rate >= 40) return { color: '#ca8a04', bg: '#fefce8', border: '#fde68a' };
    return { color: '#16a34a', bg: '#f0fdf4', border: '#bbf7d0' };
  };

  const TopicCard = ({ title, topics, section, emptyMsg, buttonLabel, accentColor }) => (
    <div className="bg-white border border-slate-200 rounded-xl shadow-sm flex flex-col flex-1 min-h-0">
      {/* Header */}
      <div className="px-4 py-3 border-b border-slate-100 flex items-center gap-2 shrink-0">
        <div className="w-2 h-4 rounded-sm" style={{ background: accentColor }} />
        <span className="text-base font-bold text-slate-800">{title}</span>
        <span className="ml-1 text-[11px] font-semibold text-blue-600 bg-blue-50 border border-blue-200 px-2 py-0.5 rounded-full">
          ✦ AI Rcmd.
        </span>
        <div className="relative group/tip ml-auto">
          <AiOutlineInfoCircle className="text-slate-400 hover:text-slate-600 transition-colors cursor-default" size={14} />
          <div className="pointer-events-none absolute bottom-full right-0 mb-2 z-[99999] w-56 opacity-0 group-hover/tip:opacity-100 transition-opacity duration-200">
            <div className="bg-white border border-slate-200 rounded-xl px-3 py-2 shadow-lg text-xs text-slate-600 leading-relaxed">
              {section === "English"
                ? "AI-analyzed weak Reading & Writing topics based on your incorrect answers."
                : "AI-analyzed weak Math topics based on your incorrect answers."}
            </div>
          </div>
        </div>
      </div>

      {/* Body */}
      {topics.length > 0 ? (
        <div className="flex-1 min-h-0 overflow-y-auto scrollbar-hide">
          <ul className="divide-y divide-slate-50">
            {topics.map((topic, index) => {
              const wrongRate = topic.total > 0 ? Math.round((topic.count / topic.total) * 100) : 100;
              const ws = getWrongStyle(wrongRate);
              return (
                <li
                  key={index}
                  className="flex items-center gap-3 px-4 py-2.5 cursor-pointer hover:bg-slate-50 transition-colors"
                  onClick={() => handleRowClick(topic.topic, section)}
                >
                  <span className="text-[11px] font-bold text-blue-500 w-6 shrink-0">
                    {toOrdinal(index + 1)}
                  </span>
                  <span className="text-sm text-slate-700 flex-1 min-w-0 truncate">
                    {topic.topic}
                  </span>
                  <span
                    className="text-[10px] font-semibold px-2 py-0.5 rounded-md border shrink-0 whitespace-nowrap"
                    style={{ color: ws.color, background: ws.bg, borderColor: ws.border }}
                  >
                    {wrongRate}% wrong
                  </span>
                </li>
              );
            })}
          </ul>
        </div>
      ) : (
        <div className="flex-1 flex flex-col items-center justify-center gap-3 py-8">
          <p className="text-sm text-slate-400">{emptyMsg}</p>
          <button
            className="px-4 py-1.5 rounded-lg text-sm font-semibold bg-blue-600 text-white hover:bg-blue-500 transition-colors"
            onClick={() => setdashboard(3)}
          >
            {buttonLabel}
          </button>
        </div>
      )}
    </div>
  );

  return (
    <div className="flex flex-col gap-3 h-full">
      <TopicCard
        title="English Topics"
        topics={topEngTopics}
        section="English"
        emptyMsg="Take the SAT to see your weak topics!"
        buttonLabel="Take a Test"
        accentColor="#3b82f6"
      />
      <TopicCard
        title="Math Topics"
        topics={topMathTopics}
        section="Math"
        emptyMsg="Start the SAT to discover your math gaps!"
        buttonLabel="Start Test"
        accentColor="#8b5cf6"
      />
    </div>
  );
};

export default MissingTopics;
